import Link from 'components/PRISMIC/Blog/Link';
import { mixpanelClick } from 'components/PRISMIC/Blog/BlogInstrumentation';
import { FilledLinkToWebField } from '@prismicio/client';

import { OurImpactSliceListLinkItem } from 'components/../../prismicio-types';
const mixpanelContext = 'slice_click';

import type { JSX } from 'react';

const LinkListComponent = ({ items, textColor }): JSX.Element => {
  return (
    <div className="flex flex-col lg-tui:flex-row lg-tui:gap-10">
      <div className="flex-1" />
      <div className="flex flex-1 flex-col gap-4">
        {items.map((item: OurImpactSliceListLinkItem) => (
          <Link
            className={textColor}
            field={item.linkurl}
            onClick={() =>
              mixpanelClick(
                mixpanelContext,
                item.linkurl as FilledLinkToWebField
              )
            }
          >
            {item.linkText}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default LinkListComponent;
